"use client";
import { jsx as r } from "react/jsx-runtime";
import { InkeepConfigProvider as t } from "./config-provider.js";
import { ThemeProvider as m } from "./theme-provider.js";
import { UserProvider as c } from "./user-provider.js";
function v(o) {
  const { children: e, config: i, componentType: n } = o;
  return /* @__PURE__ */ r(
    t,
    {
      value: {
        ...i,
        componentType: n
      },
      children: /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(c, { children: e }) })
    }
  );
}
export {
  v as RootProvider
};
